import FormattedMessage from 'I18n/components/FormattedMessage';
import unescapedText from 'I18n/utils/unescapedText';
import UITag from 'UIComponents/tag/UITag';
import { getAssetBusinessTypeTranslationKey, getAssetPageFeatureTranslationKey, getAssetPageTypeTranslationKey } from 'marketplace-ui-assets-core/utils/i18n';
import MobileTagButton from 'marketplace-ui-common/components/mobile/MobileTagButton';
import * as PlanType from 'marketplace-ui-common/constants/pricings/PlanType';
import { getTierI18nKey } from 'marketplace-ui-common/utils/i18n';
import { useMemo } from 'react';
import { useModuleCategories } from '../../../modules/hooks/useModuleCategories';
import { jsx as _jsx } from "react/jsx-runtime";
function CategoryTag({
  value
}) {
  const categories = useModuleCategories();
  try {
    const displayName = categories.getCategoryDisplayName(value);
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "marketplace-assets-ui.assets.filters.categories.tag",
      options: {
        value: displayName
      }
    });
  } catch (_unused) {
    return null;
  }
}
function PlanTypeTag({
  value
}) {
  let tagValue;
  if (value === PlanType.FREE) {
    tagValue = unescapedText('marketplace-assets-ui.assets.filters.price.free');
  } else if (value === PlanType.ONE_TIME) {
    tagValue = unescapedText('marketplace-assets-ui.assets.filters.price.paid');
  } else {
    // TODO min/max price
    tagValue = unescapedText('marketplace-assets-ui.assets.filters.price.custom');
  }
  return /*#__PURE__*/_jsx(FormattedMessage, {
    message: "marketplace-assets-ui.assets.filters.price.tag",
    options: {
      value: tagValue
    }
  });
}
const FilterTagMap = {
  businessTypes: ({
    value
  }) => /*#__PURE__*/_jsx(FormattedMessage, {
    message: "marketplace-assets-ui.assets.filters.businessType.tag",
    options: {
      value: unescapedText(getAssetBusinessTypeTranslationKey(value))
    }
  }),
  pageTypes: ({
    value
  }) => /*#__PURE__*/_jsx(FormattedMessage, {
    message: "marketplace-assets-ui.assets.filters.pageTypes.tag",
    options: {
      value: unescapedText(getAssetPageTypeTranslationKey(value))
    }
  }),
  pageFeatures: ({
    value
  }) => /*#__PURE__*/_jsx(FormattedMessage, {
    message: "marketplace-assets-ui.assets.filters.pageFeatures.tag",
    options: {
      value: unescapedText(getAssetPageFeatureTranslationKey(value))
    }
  }),
  categories: ({
    value
  }) => /*#__PURE__*/_jsx(CategoryTag, {
    value: value
  }),
  planType: ({
    value
  }) => /*#__PURE__*/_jsx(PlanTypeTag, {
    value: value
  }),
  priceRange: () => /*#__PURE__*/_jsx(FormattedMessage, {
    message: "marketplace-assets-ui.assets.filters.price.tag",
    options: {
      value: unescapedText('marketplace-assets-ui.assets.filters.price.custom')
    }
  }),
  portalCompatible: () => /*#__PURE__*/_jsx(FormattedMessage, {
    message: "marketplace-assets-ui.assets.filters.portalCompatible.tag"
  }),
  tiers: ({
    value
  }) => /*#__PURE__*/_jsx(FormattedMessage, {
    message: "marketplace-assets-ui.assets.filters.tiers.tag",
    options: {
      value: unescapedText(getTierI18nKey(value))
    }
  }),
  providers: ({
    value
  }) => /*#__PURE__*/_jsx(FormattedMessage, {
    message: "marketplace-assets-ui.assets.filters.providers.tag",
    options: {
      value
    }
  }),
  minOverallRating: ({
    value
  }) => /*#__PURE__*/_jsx(FormattedMessage, {
    message: "marketplace-assets-ui.assets.filters.rating.tag",
    options: {
      count: value
    }
  }),
  hasFreeSupport: () => /*#__PURE__*/_jsx(FormattedMessage, {
    message: "marketplace-assets-ui.assets.filters.support.tag"
  }),
  tags: ({
    value
  }) => /*#__PURE__*/_jsx(FormattedMessage, {
    message: "marketplace-assets-ui.assets.filters.searchTags.tag",
    options: {
      value
    }
  }),
  offeringTypes: ({
    value
  }) => /*#__PURE__*/_jsx(FormattedMessage, {
    message: "marketplace-assets-ui.assets.filters.offeringType.tag",
    options: {
      value: value === 'THEME' ? unescapedText('marketplace-assets-ui.assets.filters.offeringType.themes') : unescapedText('marketplace-assets-ui.assets.filters.offeringType.modules')
    }
  })
};
function isInFilterTagMap(key) {
  return key in FilterTagMap;
}
function FilterLabel({
  name,
  value
}) {
  if (isInFilterTagMap(name)) {
    const Component = FilterTagMap[name];
    return /*#__PURE__*/_jsx(Component, {
      name: name,
      value: value
    });
  }
  return null;
}
function FilterTag({
  name,
  onClear,
  value
}) {
  const testId = useMemo(() => {
    const testIdPrefix = `filter-tag::${name}`;
    switch (name) {
      case 'businessTypes':
      case 'pageTypes':
      case 'pageFeatures':
      case 'tiers':
      case 'providers':
      case 'tags':
        return `${testIdPrefix}::${value}`;
      default:
        return testIdPrefix;
    }
  }, [name, value]);
  return /*#__PURE__*/_jsx(UITag, {
    className: "m-left-0 m-right-2 m-y-1",
    closeable: true,
    "data-test-id": testId,
    inline: true,
    onCloseClick: () => onClear(name, value),
    children: /*#__PURE__*/_jsx(FilterLabel, {
      name: name,
      value: value
    })
  });
}
export function MobileFilterTag({
  name,
  onClear,
  value
}) {
  return /*#__PURE__*/_jsx(MobileTagButton, {
    closeable: true,
    onClick: () => onClear(name, value),
    children: /*#__PURE__*/_jsx(FilterLabel, {
      name: name,
      value: value
    })
  });
}
export default FilterTag;